/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Barcode from 'react-barcode';
import { random, padStart } from 'lodash';

import './styles.css';
import { useFlipOIDC } from '../../components/FlipOIDC';
import { useFlipThemes } from '../../components/FlipThemes';

function getJobTitle(title?: string) {
  if (!title) return 'Employee';
  if (title.trim().length === 0) return 'Employee';
  return title;
}

function randomNumber(length = 2) {
  if (length === 2) return padStart(String(random(0, 99)), 2, '0');
  return padStart(String(random(0, 999)), 3, '0');
}

function randomCode() {
  return `${randomNumber(3)} ${randomNumber(3)} ${randomNumber(3)} ${randomNumber(3)} ${randomNumber(3)} ${randomNumber(2)}`;
}

export default function EmployeeCard() {
  const { me } = useFlipOIDC();
  const { logo } = useFlipThemes();

  return (
    <div className="mobile-on-desktop">
      <div className="employee-card-layout">
        <img src={logo} alt="Company Logo" />
        <div className="barcode">
          <Barcode value={randomCode()} width={1} />
        </div>
        <h1>{`${me.first_name} ${me.last_name}`}</h1>
        <h2>{getJobTitle(me.user_profile.job_title)}</h2>
        <p>
          This card can be used to open doors and security areas
          depending on authorization access. In addition,
          the card’s credit can be accessed and used to make payments.
        </p>
      </div>
    </div>
  );
}
